export default __webpack_public_path__ + "static/bold-e171efa58e05a5ccc62a280049dff5c8.woff2";